module.exports = __webpack_public_path__ + "img/viettelpost.2595b6e3.png";